import localizationData from "./data/localization.json";
import servicesData from "./data/services.json";
import experiencesData from "./data/experience.json";
import projectsData from "./data/projects.json";
import skillsData from "./data/skills.json";
import aboutMeData from "./data/aboutme.json";
export const PORTFOLIO_OWNER = "Martin J. Skalický";
export const CONTACT_EMAIL = "web@skali.eu";
// Helper function to merge localized data with base English data
function mergeWithEnglish(data) {
    const result = {};
    const languages = ["en", "cz", "de"];
    languages.forEach((lang) => {
        if (lang === "en") {
            result[lang] = data[lang];
        }
        else {
            result[lang] = data.en.map((enItem, index) => ({
                ...enItem,
                ...(data[lang]?.[index] || {}),
            }));
        }
    });
    return result;
}
export const CONTENT = localizationData;
export const SERVICES_DATA = mergeWithEnglish(servicesData);
export const EXPERIENCES_DATA = mergeWithEnglish(experiencesData);
export const PROJECTS_DATA = mergeWithEnglish(projectsData);
export const SKILLS = skillsData;
export const ABOUT_ME_DATA = aboutMeData;
export const SOCIAL_LINKS = [
    {
        name: "GitHub",
        url: "https://github.com/maskalix",
        icon: "mdi:github",
    },
    {
        name: "LinkedIn",
        url: "https://www.linkedin.com/in/martin-skalickyy/",
        icon: "mdi:linkedin",
    },
    {
        name: "Email",
        url: "mailto:web@skali.eu",
        icon: "mdi:email",
    },
];
